import React, { useEffect } from "react";
import { buildIdLoginUrl, getDefaultReturnToUrl, redirectToIdLogin } from "./idp";

const LoginPage: React.FC = () => {
    const returnTo = getDefaultReturnToUrl();

    useEffect(() => {
        redirectToIdLogin(returnTo);
    }, [returnTo]);

    return (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
            <div style={{ width: "min(440px, 100%)", background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 18px 40px rgba(12,38,63,0.12)" }}>
                <h2 style={{ marginTop: 0 }}>Переход в авторизацию</h2>
                <p style={{ opacity: 0.8, lineHeight: 1.5 }}>
                    Перенаправляем в общий сервис авторизации `id`. Если переход не сработал автоматически,
                    откройте логин вручную.
                </p>
                <button
                    type="button"
                    onClick={() => redirectToIdLogin(returnTo)}
                    style={{
                        border: 0,
                        borderRadius: 12,
                        background: "#0c263f",
                        color: "#fff",
                        padding: "12px 18px",
                        cursor: "pointer",
                    }}
                >
                    Открыть логин
                </button>
                <div style={{ marginTop: 12, fontSize: 13, opacity: 0.65, wordBreak: "break-all" }}>
                    {buildIdLoginUrl(returnTo)}
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
